var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle4, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUndrawHello = function SvgUndrawHello(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 979.33 424.84"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M883.38 175.26H308.81a9.2 9.2 0 0 0 0 18.4h16.27v220.06a9.2 9.2 0 0 0 18.4 0l.14-220.06h461.15l42.52 220.06a9.2 9.2 0 1 0 18.4 0l2.68-220.06h15.01a9.2 9.2 0 0 0 0-18.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M408.4 134.27v38.95h-97.6a19.49 19.49 0 1 1-1.35-38.95q.68-.02 1.35 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410.8 172.92a1.5 1.5 0 0 1-1.5 1.5H309.07a20.53 20.53 0 0 1 0-41.05H409.3a1.5 1.5 0 1 1 0 3H309.07a17.53 17.53 0 0 0 0 35.06H409.3a1.5 1.5 0 0 1 1.5 1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M408.4 143.26H303.52a.3.3 0 0 1 0-.6H408.4a.3.3 0 0 1 0 .6ZM408.4 150.45H303.52a.3.3 0 0 1 0-.6H408.4a.3.3 0 0 1 0 .6ZM408.4 157.64H303.52a.3.3 0 0 1 0-.6H408.4a.3.3 0 0 1 0 .6ZM408.4 164.83H303.52a.3.3 0 0 1 0-.6H408.4a.3.3 0 0 1 0 .6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M390 93.23v38.95h-97.6a19.49 19.49 0 0 1-1.35-38.95q.68-.03 1.36 0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M392.4 131.88a1.5 1.5 0 0 1-1.5 1.5H290.67a20.53 20.53 0 0 1 0-41.05H390.9a1.5 1.5 0 1 1 0 3H290.67a17.53 17.53 0 0 0 0 35.05H390.9a1.5 1.5 0 0 1 1.5 1.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M390 102.22H285.12a.3.3 0 0 1 0-.6H390a.3.3 0 0 1 0 .6ZM390 109.4H285.12a.3.3 0 0 1 0-.59H390a.3.3 0 0 1 0 .6ZM390 116.6H285.12a.3.3 0 0 1 0-.6H390a.3.3 0 0 1 0 .6ZM390 123.8H285.12a.3.3 0 0 1 0-.6H390a.3.3 0 0 1 0 .6ZM503.54 313.1v-33.96a5.66 5.66 0 0 0-5.66-5.66H369.09a5.66 5.66 0 0 0-5.66 5.66v33.96ZM363.43 325.84h140.11v43.87H363.43zM363.43 382.45v33.96a5.66 5.66 0 0 0 5.66 5.66h128.79a5.66 5.66 0 0 0 5.66-5.66v-33.96Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 432.78,
    cy: 294.7,
    r: 4.25,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.78,
    cy: 351.31,
    r: 4.25,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 433,
    cy: 406.72,
    r: 4.25,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M487.65 234.75v38.95h-97.6a19.49 19.49 0 0 1-1.35-38.95q.68-.02 1.36 0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M490.05 273.4a1.5 1.5 0 0 1-1.5 1.5H388.32a20.53 20.53 0 0 1-.03-41.05h100.26a1.5 1.5 0 1 1 0 3H388.32a17.53 17.53 0 0 0 0 35.06h100.23a1.5 1.5 0 0 1 1.5 1.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M487.65 243.74H382.77a.3.3 0 0 1 0-.6h104.88a.3.3 0 0 1 0 .6ZM487.65 250.93H382.77a.3.3 0 0 1 0-.6h104.88a.3.3 0 0 1 0 .6ZM487.65 258.12H382.77a.3.3 0 0 1 0-.6h104.88a.3.3 0 0 1 0 .6ZM487.65 265.31H382.77a.3.3 0 0 1 0-.6h104.88a.3.3 0 0 1 0 .6Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M373.03 80.23h-44.46a2.75 2.75 0 0 0-1.22.29l-11.22 5.61a2.05 2.05 0 0 0 0 3.77l11.22 5.62a2.75 2.75 0 0 0 1.22.28h44.46a2.33 2.33 0 0 0 2.46-2.17V82.4a2.33 2.33 0 0 0-2.46-2.17Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M375.5 82.4v11.23a2.33 2.33 0 0 1-2.47 2.17h-8.86V80.23h8.86a2.33 2.33 0 0 1 2.46 2.17Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M106.44 300.41a35.34 35.34 0 0 0 34.13-6.01c11.95-10.03 15.7-26.56 18.75-41.86q4.5-22.64 9.02-45.27l-18.88 13c-13.58 9.35-27.47 19-36.87 32.54s-13.5 32.03-5.95 46.69"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M108.06 355.22c-1.91-13.93-3.88-28.02-2.54-42.1 1.2-12.49 5-24.7 12.77-34.7A57.74 57.74 0 0 1 133.1 265c1.48-.94 2.84 1.4 1.37 2.34a54.89 54.89 0 0 0-21.71 26.2c-4.73 12.02-5.49 25.12-4.67 37.9.49 7.72 1.53 15.4 2.59 23.05a1.4 1.4 0 0 1-.95 1.67 1.37 1.37 0 0 1-1.67-.94Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M126.47 330.58a26.01 26.01 0 0 0 22.66 11.7c11.48-.54 21.04-8.55 29.65-16.15l25.47-22.5-16.85-.8c-12.13-.58-24.56-1.12-36.1 2.62s-22.2 12.73-24.31 24.68"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M102.66 363.22c9.2-16.28 19.87-34.37 38.93-40.15a43.45 43.45 0 0 1 16.38-1.69c1.73.15 1.3 2.83-.44 2.68a40.36 40.36 0 0 0-26.13 6.91c-7.37 5.02-13.1 12-17.96 19.39-2.97 4.53-5.64 9.25-8.3 13.96-.86 1.51-3.34.42-2.48-1.1Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M87.92 380.35a19.7 19.7 0 0 1 12.07-16.5v-9.4h15.78v9.7a19.69 19.69 0 0 1 11.42 16.2l3.7 43.14H84.22Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m624.64 174.37-4.7-1.97-3.22-23.54h-42.89l-3.49 23.44-4.2 2.1a1 1 0 0 0 .45 1.89h57.66a1 1 0 0 0 .39-1.92Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M700.85 152H490.17a4.17 4.17 0 0 1-4.16-4.18V118.1h219v29.7a4.17 4.17 0 0 1-4.16 4.18Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M705.24 132.15H485.8V5.03A5.04 5.04 0 0 1 490.85 0H700.2a5.04 5.04 0 0 1 5.03 5.03Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M692.13 122.92H498.92a3.88 3.88 0 0 1-3.88-3.87V13.1a3.88 3.88 0 0 1 3.88-3.88h193.21a3.88 3.88 0 0 1 3.88 3.88v105.94a3.88 3.88 0 0 1-3.88 3.87Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "M641.24 160.3a11.62 11.62 0 0 1 17.67 2.28l26.13-4.65 6.7 15.2-37 6.04a11.68 11.68 0 0 1-13.5-18.87Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m665.44 179.7 27.25-.34 3.44-.04 55.44-.7s15.05-14.36 28.16-29.15l-1.84-13.29a54.3 54.3 0 0 0-18.2-33.61c-18.78 12.54-29.66 37.37-29.66 37.37l-34.37 8.22-3.44.83-21.36 5.1Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e4e4",
    d: "M804.91 261.38h-50.85c0 2.18-55.6 3.95-55.6 3.95a20.3 20.3 0 0 0-3.33 3.16 19.6 19.6 0 0 0-4.58 12.63v3.16a19.75 19.75 0 0 0 19.74 19.74h94.62a19.76 19.76 0 0 0 19.74-19.74v-3.16a19.77 19.77 0 0 0-19.74-19.74Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e4e4",
    d: "M747.4 303.23h20.53v118.49H747.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e4e4",
    d: "M688.98 421c0 2.22 31.1.86 69.48.86s69.48 1.36 69.48-.86-31.11-19.8-69.48-19.8-69.48 17.58-69.48 19.8Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "M675.19 407.46h-15.28l-7.27-58.93h22.55v58.93z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M679.08 422.27h-49.26v-.62a19.18 19.18 0 0 1 19.17-19.18h30.1Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "M630.03 407.46h-15.28l-7.26-58.93h22.54v58.93z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M633.93 422.27h-49.27v-.62a19.18 19.18 0 0 1 19.18-19.18h30.09Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.89,
    cy: 41.64,
    r: 26.56,
    fill: "#ffb6b6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M809.88 223.64s8.91 47.13-25 53.13S702.01 287 702.01 287l-21.98 102.57-29.53-2.64s3.92-123.46 13.58-133.12 70.72-38.59 70.72-38.59Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m743.65 203.89-14.84 14.88s-107.09 17.25-111.22 41.98c-6.24 37.35-13.6 118.56-13.6 118.56l32.2-2.42 12.62-92.31 51.52-11.72 58.61-31.94ZM792.45 25.78c-2.62-4.95-5.96-14.8-11.25-16.64a42.08 42.08 0 0 0-9.06-1.93l-9 3.46 4.9-3.8q-1.43-.09-2.85-.14l-6.07 2.33 3.1-2.41c-5.66-.06-11.5.53-15.88 3.97-3.74 2.94-7.45 14.06-8.04 18.78a35.92 35.92 0 0 0 .66 13.53l1.53 1.46a18.86 18.86 0 0 0 1.2-3.84 18.18 18.18 0 0 1 8.71-11.8l.09-.05c2.57-1.45 5.7-1.39 8.66-1.28l14.04.5c3.38.13 7.02.34 9.65 2.46a15.89 15.89 0 0 1 3.86 5.59c1.3 2.64 3.86 12.6 3.86 12.6s1.45-1.88 2.14-.48a48.4 48.4 0 0 0 2.02-11.23 22 22 0 0 0-2.27-11.08Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "M885.36 53.3a11.62 11.62 0 0 0-10.52 14.38l-21.36 15.76 6.41 15.31 29.86-22.67a11.68 11.68 0 0 0-4.4-22.78Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m881.92 85.47-53.55 59.47s-25.61-8.2-45.42-17.08l-8.9-27.33a54.34 54.34 0 0 1-2.6-19.66c27.46-7.31 59.4 19.87 59.4 19.87l40.08-31.4Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M756.96 228.04c-9.55-3.3-19.43-6.72-30.08-8l-.46-.05.12-.45c11.03-38.73 8.28-63.5 2.88-100.72a37.6 37.6 0 0 1 21.54-39.5l.07-.03 30.43-1.93h.07l22.14 6.5a15.18 15.18 0 0 1 10.86 14.83c-.24 12.24.27 25.9.81 40.37 1.21 32.46 2.46 66.02-4.63 87.8l-.04.1-.09.08a36.1 36.1 0 0 1-23.08 8.11c-9.94 0-20.07-3.5-30.54-7.11Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M977.91 424.84H1.41a1.42 1.42 0 1 1 0-2.83h976.5a1.42 1.42 0 1 1 0 2.83Z"
  })));
};
export default SvgUndrawHello;